function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import BrandButton from "../BrandButton";
var StyledBox = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  return "\n  & {\n    display: flex;\n    justify-content: space-between;\n    padding-block: 1rem;\n    padding-inline: 0.7rem;\n    \n    border: 2px dashed ".concat(theme.palette.primary[200], ";\n    border-radius: 4px;\n    \n    &:hover {\n      border: 2px dashed ").concat(theme.palette.primary[400], ";\n    }\n  }\n");
});
function FileNameList(_ref2) {
  var files = _ref2.files,
    onClear = _ref2.onClear,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleClick = function handleClick(event) {
    if (disabled) return;
    event.stopPropagation();
    onClear();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      gap: 1
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    component: "p"
  }, t('core_input_file_file_names')), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    onClick: function onClick(event) {
      return handleClick(event);
    },
    sx: {
      p: 0,
      color: 'error.main',
      ':hover': {
        cursor: 'pointer'
      }
    }
  }, t('core_input_file_action_clear_files'))), !!files.map && files.map(function (f, i) {
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      component: "p",
      key: i
    }, f.name);
  }));
}
function BrandFileInput(_ref3) {
  var label = _ref3.label,
    type = _ref3.type,
    onChange = _ref3.onChange,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    _ref3$multiple = _ref3.multiple,
    multiple = _ref3$multiple === void 0 ? false : _ref3$multiple,
    _ref3$files = _ref3.files,
    files = _ref3$files === void 0 ? [] : _ref3$files,
    args = _ref3.args,
    children = _ref3.children;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var fileInputRef = useRef(null);
  var dragOverCount = useRef(0);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    uploadError = _useState4[0],
    setUploadError = _useState4[1];
  var acceptedFileTypes = useMemo(function () {
    switch (type) {
      case 'image':
        return ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'];
      case 'text':
      default:
        return ['application/vnd.oasis.opendocument.text', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf', 'text/plain', 'text/markdown'];
    }
  }, [type]);
  var formattedFileTypes = useMemo(function () {
    switch (type) {
      case 'image':
        return 'JPEG, JPG, PNG, GIF';
      case 'text':
      default:
        return '.txt, .doc, .docx, .odt, .md, .pdf';
    }
  }, [type]);
  var isValidPayload = function isValidPayload(payload) {
    var _payload$items;
    return ((_payload$items = payload.items) === null || _payload$items === void 0 ? void 0 : _payload$items.length) && Object.values(payload.items).every(function (i) {
      return i.kind === 'file';
    });
  };
  var isValidFile = function isValidFile(file) {
    if (!file) throw new Error(t('core_input_file_error_dne'));
    if (!acceptedFileTypes.includes(file.type)) throw new Error(t('core_input_file_error_invalid_type_x', {
      type: type
    }));
    if (file.size > 10000000) throw new Error(t('core_input_file_error_size'));
    return file;
  };
  var validateFiles = function validateFiles(fileList) {
    try {
      if (!multiple && fileList.length > 1) throw new Error(t('core_input_file_error_too_many'));
      var validatedFiles = fileList.reduce(function (list, file) {
        return [].concat(_toConsumableArray(list), [isValidFile(file.getAsFile ? file.getAsFile() : file)]);
      }, []);
      setUploadError('');
      return validatedFiles;
    } catch (err) {
      setUploadError(err.message);
      return [];
    }
  };
  var handleClick = function handleClick() {
    fileInputRef.current.click();
  };
  var handleClear = function handleClear() {
    onChange([]);
    setUploadError('');
  };
  var browseInputHandler = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = onChange;
            _context.next = 3;
            return validateFiles(Object.values(event.target.files));
          case 3:
            _context.t1 = _context.sent;
            (0, _context.t0)(_context.t1);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function browseInputHandler(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleDrag = function handleDrag(event) {
    event.preventDefault();
    event.stopPropagation();
  };
  var handleDrop = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            event.preventDefault();
            event.stopPropagation();
            _context2.t0 = onChange;
            _context2.next = 5;
            return validateFiles(Object.values(event.dataTransfer.items));
          case 5:
            _context2.t1 = _context2.sent;
            (0, _context2.t0)(_context2.t1);
            dragOverCount.current = 0;
            setIsDragging(false);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleDrop(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleDragEnter = function handleDragEnter(event) {
    event.preventDefault();
    event.stopPropagation();
    dragOverCount.current++;
    if (isValidPayload(event.dataTransfer)) {
      setIsDragging(true);
    }
  };
  var handleDragLeave = function handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    dragOverCount.current--;
    if (dragOverCount.current === 0) {
      setIsDragging(false);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledBox, _extends({
    sx: {
      opacity: isDragging ? '45%' : '100%'
    },
    onClick: function onClick() {
      return handleClick();
    },
    onDragOver: function onDragOver(event) {
      return handleDragEnter(event);
    },
    onDragLeave: function onDragLeave(event) {
      return handleDragLeave(event);
    },
    onDrop: function onDrop(event) {
      return handleDrop(event);
    },
    onDrag: function onDrag(event) {
      return handleDrag(event);
    }
  }, args), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    component: "label"
  }, t("core_input_file_instructions_".concat(multiple ? 'many' : 'one'))), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    component: "label"
  }, t('core_input_file_restrictions_x', {
    size: '8',
    accept: formattedFileTypes
  })), !!(files !== null && files !== void 0 && files.length) && /*#__PURE__*/React.createElement(Box, {
    sx: {
      mt: '0.50rem'
    }
  }, /*#__PURE__*/React.createElement(FileNameList, {
    disabled: disabled,
    files: files || [],
    onClear: function onClear() {
      return handleClear();
    }
  })), !!uploadError && /*#__PURE__*/React.createElement(Box, {
    sx: {
      mt: '0.5rem'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    component: "p",
    sx: {
      color: 'error.main'
    }
  }, uploadError)), children && /*#__PURE__*/React.createElement(Box, {
    sx: {
      mt: '0.50rem'
    }
  }, children)), /*#__PURE__*/React.createElement(BrandButton, {
    sx: {
      backgroundColor: 'primary.400',
      flexBasis: 0,
      whiteSpace: 'nowrap',
      px: '2rem',
      overflow: 'hidden'
    },
    disabled: disabled
  }, label || t('core_input_file_action_browse'))), /*#__PURE__*/React.createElement("input", {
    ref: fileInputRef,
    type: "file",
    accept: acceptedFileTypes,
    multiple: multiple,
    disabled: disabled,
    style: {
      display: 'none'
    },
    onChange: function onChange(event) {
      return browseInputHandler(event);
    }
  }));
}
BrandFileInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(['image', 'text']),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  files: PropTypes.array,
  args: PropTypes.object,
  children: PropTypes.any
};
export default BrandFileInput;